<script setup lang="ts">
import { localize } from "@/utils";
</script>

<template>
  <router-view></router-view>
</template>

<style scoped></style>
